<div class="wrapper">
  <div class="emr-page-container">

    @if (!loaded()) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    } @else {
      @if (patient(); as localPatient) {
      @if (providerOrder(); as localProviderOrder) {
      <div class="emr-page-title">Released {{localProviderOrder.medName}}</div>
      <div class="medicationInfo">
        <span>
          Quantity: {{localProviderOrder.quantity}}
        </span>
        <span>
          Dosage: {{localProviderOrder.dosage}}
        </span>
        <span>
          Time: {{localProviderOrder.startTime.hour.toString()
          .padStart(2, '0')}}:{{localProviderOrder.startTime.minute.toString()
          .padStart(2, '0')}}
        </span>
      </div>
      @if (localProviderOrder.medControlledSubstance) {
      <div class="controlled-substance-div">
        <p>This is a controlled substance.</p>
        <p>There are {{containerQuantity}} doses in the drawer.</p>
        <p>Please remove the correct dosage.</p>
        <p-checkbox inputId="verifyControlledMedsRemaining" [binary]="true"
          [(ngModel)]="verifyControlledMedsRemaining" />
        <label class="leftovers-remaining" for="verifyControlledMedsRemaining">
          I have verified there are {{quantityRemaining}} doses remaining.
        </label>
      </div>
      <b>Is there waste?</b>
      <div>
        <p-selectbutton size="small" [options]="yesNo" [(ngModel)]="isThereWaste" optionLabel="label"
          optionValue="value" aria-labelledby="basic" />

        @if (localProviderOrder.medControlledSubstance && isThereWaste) {
        Second RN:
        <input class="waste-input" pInputText placeholder="Enter amount of waste" width="40"
          [(ngModel)]="secondRNwasteAmt">
        <input class="waste-input" pInputText placeholder="Second RN signature" width="40"
          [(ngModel)]="secondRNsignature">
        }
      </div>
      }
      @if (anyContainersOpen &&
      (!localProviderOrder.medControlledSubstance ||
      verifyControlledMedsRemaining && (!isThereWaste || (secondRNsignature && secondRNwasteAmt)))) {
      <div id="containerOpen">
        Close the container to continue
        <button pButton class="p-button-secondary" (click)="closeContainer()">(Close)</button>
      </div>
      }
      }

      @if (openedContainerId(); as localOpenedContainerId) {
      <div id="knightmedsDiagram">
        <app-knightmeds-diagram [highlightedContainerId]="highlightedContainerId()"></app-knightmeds-diagram>
      </div>
      } @else {
      <span class="error">No container with a sufficient quantity of the medication was found</span>
      }

      <div class="buttons">
        @if (nextProviderOrderId(); as localNextProviderOrderId) {
        <button pButton class="p-button-primary"
          [routerLink]="['/', 'release', 'release', localPatient.id, localNextProviderOrderId]"
          [queryParams]="moreProviderOrderIds()" [disabled]="anyContainersOpen">
          Release Next Medication
        </button>
        } @else {
        <button pButton class="p-button-primary" [routerLink]="'/release'"
          [disabled]="anyContainersOpen">
          Select Another Patient
        </button>

        <button pButton class="p-button-primary" [routerLink]="'/login'" [disabled]="anyContainersOpen">
          Logout
        </button>
        }
      </div>
      }
    }
  </div>
</div>